<template>
  <div>
    <p>
      <strong>{{ title }}</strong><br>
      {{ name }}
      <small>{{ address }}</small>
    </p>

    <button v-if="haveLocation" @click="setLocation" class="btn btn-xs btn-info m-b-md" data-toggle="modal" data-target=".modal-location-details">
      View Details
    </button>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex'
  import { SET_LOCATION } from 'vx/mutations'

  export default {
    props: ['location', 'title'],

    computed: {
      haveLocation () {
        return this.location !== null && this.location !== undefined
      },

      name () {
        return this.haveLocation ? this.location.formattedName : '–'
      },

      address () {
        return this.haveLocation ? this.location.address : '–'
      }
    },

    methods: {
      ...mapMutations('location', [SET_LOCATION]),

      /**
       * Set the active location when opening the modal.
       */
      setLocation () {
        this[SET_LOCATION](this.location.decorated)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LocationDetail.vue?65001c32